import React, { memo } from 'react';

const AdvancedSearchRow = memo(({ children }) => {
    if (!children) return null;

    return <div className="fm-entity-merge__advanced-search-row">{children}</div>;
});

export default AdvancedSearchRow;
